"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpSynonymsValidateSynonymResponseErrorEnum;
(function (TableauNlpSynonymsValidateSynonymResponseErrorEnum) {
    TableauNlpSynonymsValidateSynonymResponseErrorEnum["NoValidationError"] = "NO_VALIDATION_ERROR";
    TableauNlpSynonymsValidateSynonymResponseErrorEnum["UnderMinLength"] = "UNDER_MIN_LENGTH";
    TableauNlpSynonymsValidateSynonymResponseErrorEnum["OverMaxLength"] = "OVER_MAX_LENGTH";
    TableauNlpSynonymsValidateSynonymResponseErrorEnum["InvalidDataType"] = "INVALID_DATA_TYPE";
    TableauNlpSynonymsValidateSynonymResponseErrorEnum["InvalidCharacter"] = "INVALID_CHARACTER";
    TableauNlpSynonymsValidateSynonymResponseErrorEnum["ReservedAnalyticalTerm"] = "RESERVED_ANALYTICAL_TERM";
})(TableauNlpSynonymsValidateSynonymResponseErrorEnum = exports.TableauNlpSynonymsValidateSynonymResponseErrorEnum || (exports.TableauNlpSynonymsValidateSynonymResponseErrorEnum = {}));
function TableauNlpSynonymsValidateSynonymResponseFromJSON(json) {
    return TableauNlpSynonymsValidateSynonymResponseFromJSONTyped(json, false);
}
exports.TableauNlpSynonymsValidateSynonymResponseFromJSON = TableauNlpSynonymsValidateSynonymResponseFromJSON;
function TableauNlpSynonymsValidateSynonymResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'valid': !runtime_1.exists(json, 'valid') ? undefined : json['valid'],
        'error': !runtime_1.exists(json, 'error') ? undefined : json['error'],
        'invalidSynonymIndex': !runtime_1.exists(json, 'invalidSynonymIndex') ? undefined : json['invalidSynonymIndex'],
    };
}
exports.TableauNlpSynonymsValidateSynonymResponseFromJSONTyped = TableauNlpSynonymsValidateSynonymResponseFromJSONTyped;
function TableauNlpSynonymsValidateSynonymResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'valid': value.valid,
        'error': value.error,
        'invalidSynonymIndex': value.invalidSynonymIndex,
    };
}
exports.TableauNlpSynonymsValidateSynonymResponseToJSON = TableauNlpSynonymsValidateSynonymResponseToJSON;
